"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const convertEventDetails_1 = require("./convertEventDetails");
const registerEvents_1 = require("./registerEvents");
/**
 * Register events that were specified in the TrackedEventDetails.eventDetails
 * config option during initialization. Events are inserted into the event
 * registry *in-place*. If two events share the same name, only the last one
 * will be registered.
 *
 * @example
 * // If events in the TrackedEventDetails config option are specified like so:
 * ClientProfiler.appConfig.trackedEventDetails.eventDetails = [
 *     {
 *         eventA: {
 *             thresholds: { delighted: 100, satisfied: 200 },
 *         },
 *     },
 *     {
 *         eventB: {
 *             dynamicEvent: true,
 *             thresholds: { delighted: 200, satisfied: 300 },
 *         },
 *     },
 *     {
 *         eventC: {
 *             dynamicEvent: true,
 *             graphiteName: 'custom-graphite-name',
 *             thresholds: { delighted: 400, satisfied: 500 },
 *         },
 *     },
 *
 *     // Duplicate event names! This one will take precedence when registered.
 *     {
 *         eventC: {
 *             thresholds: { delighted: 600, satisfied: 700 },
 *         },
 *     },
 * ];
 *
 * // ... then the registered events will be:
 * {
 *     eventA: { thresholds: [100, 200] },
 *     eventB: { isDynamic: true, thresholds: [200, 300] },
 *     eventC: { thresholds: [600, 700] },
 * };
 *
 * @warning This function mutates the `eventRegistry` object
 * @deprecated Registering events via the `trackedEventDetails` config option is
 *   deprecated. Use `registerEvent()` instead.
 * @todo Remove once all built-in events are registered via `registerEvent()`.
 *   See PERF-836.
 */
function registerTrackedEvents(profiler) {
    var _a;
    const { internalConfig } = profiler;
    const trackedEvents = (_a = internalConfig === null || internalConfig === void 0 ? void 0 : internalConfig.trackedEventDetails) === null || _a === void 0 ? void 0 : _a.eventDetails;
    // Bail if no event details were specified during initialization
    if (!trackedEvents)
        return;
    trackedEvents.forEach((trackedEvent) => {
        const eventName = Object.keys(trackedEvent)[0];
        const eventDetails = (0, convertEventDetails_1.createEventDetails)(trackedEvent);
        (0, registerEvents_1.registerEvent)(profiler, eventName, eventDetails);
    });
}
exports.default = registerTrackedEvents;
